// removed by extract-text-webpack-plugin
module.exports = {"card":"Staff__card___40JUT","cardHeader":"Staff__cardHeader___1xFMm","cardText":"Staff__cardText___V9-GI","peopleMainInfo":"Staff__peopleMainInfo___1N7Pu","peopleMainInfoLeft":"Staff__peopleMainInfoLeft___3N4WP","peopleMainInfoRight":"Staff__peopleMainInfoRight___3wLOi"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/StaffDetail/components/Staff.scss
// module id = 1225
// module chunks = 1